/**
 *
 *  SessionLink
 *  UI-kit Component
 *
 *  Created by Vladimir Shishlyannikov on 02/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 */

import React from "react";
import { Link } from "react-router-dom";
import ArrowRightIcon from "../../icons/ArrowRightIcon";

const colors = {
  coral:
    "tbk-text-coral hover:tbk-text-coral-light active:tbk-text-coral-light focus:tbk-text-coral-light disabled:tbk-text-grey-light",
  blue: "tbk-bg-blue tbk-border-blue hover:tbk-bg-blue-light hover:tbk-border-blue-light active:tbk-bg-blue-light active:tbk-border-blue-light active:tbk-text-basic-white focus:tbk-bg-blue-light focus:tbk-border-blue-light disabled:tbk-bg-grey-light disabled:tbk-border-grey-light disabled:tbk-text-blue-grey tbk-text-basic-white",
  green:
    "tbk-bg-green tbk-border-green hover:tbk-bg-green-light hover:tbk-border-green-light active:tbk-bg-green-light active:tbk-border-green-light active:tbk-text-basic-white focus:tbk-bg-green-light focus:tbk-border-green-light disabled:tbk-bg-grey-light disabled:tbk-border-grey-light disabled:tbk-text-green-grey tbk-text-basic-white",
};

export const SessionLink = ({ children, to, color, onClick }) => {
  let colorClasses = colors[color || "coral"];

  return (
    <>
      {to ? (
        <Link
          target="_blank"
          to={to}
          className={`tb-session-link tbk-text-main tbk-inline-flex ${colorClasses}`}
          onClick={onClick}
        >
          {children}
          <ArrowRightIcon />
        </Link>
      ) : (
        <button
          className={`tb-session-link tbk-text-main tbk-inline-flex ${colorClasses}`}
          onClick={onClick}
        >
          {children}
          <ArrowRightIcon />
        </button>
      )}
    </>
  );
};

export default SessionLink;
